import axios from "axios";

const tg = window.Telegram.WebApp;
const getUserId = () => tg?.initDataUnsafe?.user?.id || 0;
const tg_id = getUserId();

const sendLogout = () => {
    axios.post('https://api.gmpapp.ru/gmp_logout', { tg_id: tg_id })
        .then((response) => {
            console.log('Событие успешно отправлено в Flask');
            window.location.reload();
        })
        .catch((error) => {
            console.error('Ошибка при отправке события в Flask:', error);
            window.location.reload();
        });
};

export default sendLogout;